import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const assetBucket = (data: AssetBucketingDTO) => {
  return authFetch('/Adviser/AssetBucketing/Save', {
    method: 'POST',
    ...httpBodyOptions(data, true),
  });
};

export const useAssetBucketMutation = () => {
  return useMutation(assetBucket);
};
